import * as TYPE from './types';
import { apiAction } from '../../api/actions';

// Cards endpoint
export function getCards() {
  return (dispatch) => {
    dispatch({ type: TYPE.GET_DASHBOARD_CARDS });
    return dispatch(apiAction({
      resource: '/su/dashboard/cards',
      onSuccess: (data) => onGetCardsSuccess(data),
      onFailure: (error) => onGetCardsFailed(error),
      carry: {
        label: TYPE.GET_DASHBOARD_CARDS
      },
    }));
  };
};

function onGetCardsSuccess(data) {
  return {
    type: TYPE.GET_DASHBOARD_CARDS_SUCCESS,
    payload: data,
  };
};

function onGetCardsFailed(error) {
  return {
    type: TYPE.GET_DASHBOARD_CARDS_FAILED,
    payload: {
      error
    }
  };
};

// Charts endpoint
export function getCharts() {
  return (dispatch) => {
    dispatch({ type: TYPE.GET_DASHBOARD_CHARTS });
    return dispatch(apiAction({
      resource: '/su/dashboard/charts',
      onSuccess: (data) => onGetChartsSuccess(data),
      onFailure: (error) => onGetChartsFailed(error),
      carry: {
        label: TYPE.GET_DASHBOARD_CHARTS
      },
    }));
  };
};

function onGetChartsSuccess(data) {
  return {
    type: TYPE.GET_DASHBOARD_CHARTS_SUCCESS,
    payload: data,
  };
};

function onGetChartsFailed(error) {
  return {
    type: TYPE.GET_DASHBOARD_CHARTS_FAILED,
    payload: {
      error
    }
  };
};

// Recent controls endpoint
export function getRecentControls() {
  return (dispatch) => {
    dispatch({ type: TYPE.GET_DASHBOARD_RECENT_CONTROLS });
    return dispatch(apiAction({
      resource: '/su/dashboard/recent-controls',
      onSuccess: (data) => onGetRecentControlsSuccess(data),
      onFailure: (error) => onGetRecentControlsFailed(error),
      carry: {
        label: TYPE.GET_DASHBOARD_RECENT_CONTROLS
      },
    }));
  };
};

function onGetRecentControlsSuccess(data) {
  return {
    type: TYPE.GET_DASHBOARD_RECENT_CONTROLS_SUCCESS,
    payload: data,
  };
};

function onGetRecentControlsFailed(error) {
  return {
    type: TYPE.GET_DASHBOARD_RECENT_CONTROLS_FAILED,
    payload: {
      error
    }
  };
};

// Calendar events
export function getCalendarEvents(params) {
  return (dispatch) => new Promise((resolve, reject) => {
    dispatch(apiAction({
      resource: '/su/calendar/events',
      params,
      method: 'GET',
      onSuccess: (data) => resolve(data),
      onFailure: (error) => reject(error),
    }));
  });
};

// Calendar controllers
export function getCalendarControllers() {
  return (dispatch) => new Promise((resolve, reject) => {
    dispatch(apiAction({
      resource: '/su/calendar/controllers',
      method: 'GET',
      onSuccess: (data) => resolve(data),
      onFailure: (error) => reject(error),
    }));
  });
};

// Update controller color
export function updateControllerColor(userId, color) {
  return (dispatch) => new Promise((resolve, reject) => {
    dispatch(apiAction({
      resource: `/su/calendar/controllers/${userId}/color`,
      method: 'PATCH',
      data: { color },
      onSuccess: (data) => resolve(data),
      onFailure: (error) => reject(error),
    }));
  });
};

// Cancel calendar event
export function cancelCalendarEvent(type, controlId) {
  return (dispatch) => new Promise((resolve, reject) => {
    dispatch(apiAction({
      resource: `/su/calendar/events/${type}/${controlId}/cancel`,
      method: 'PATCH',
      data: {},
      onSuccess: (data) => resolve(data),
      onFailure: (error) => reject(error),
    }));
  });
};

// Update event date (for drag and drop rescheduling)
export function updateEventDate(controlId, newDate) {
  return (dispatch) => new Promise((resolve, reject) => {
    dispatch(apiAction({
      resource: `/su/calendar/events/${controlId}/date`,
      method: 'PATCH',
      data: { newDate },
      onSuccess: (data) => resolve(data),
      onFailure: (error) => reject(error),
    }));
  });
};

// Schedule inspection
export function scheduleInspection(requestData) {
  return (dispatch) => new Promise((resolve, reject) => {
    dispatch(apiAction({
      resource: '/su/control/schedule',
      method: 'POST',
      data: requestData,
      onSuccess: (result) => resolve(result),
      onFailure: (error) => reject(error),
    }));
  });
};